import defaultColor from "@/components/color";

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '[55]',
    },
    attribute:{
        colors: ['#3adae0','#3adae0'], waveNum: 3, waveHeight: 40, waveOpacity: 0.4, formatter: '{value}',shape: 'roundRect',//水位图形状rect/roundRect/round
        cptTableData:[{"name":"值","value":"","namekey":"value"},]
    },
}